import { giphyDarkCharcoal, giphyLightGrey, giphyWhite } from '@giphy/colors'
import { useContext } from 'react'
import EllipsisDropdown from 'shared/components/ui/ellipsis-dropdown'
import MessageContext from 'shared/contexts/message'
import UserContext from 'shared/contexts/user'
import styled, { css } from 'styled-components'
import CreationToolGradient from '../../../../../types/gradient'
import CreationToolUIAnimation from '../../../../../types/ui-animation'
import { CreationCaptureInfoContext } from '../../../../supercut/shared/components/capture-info/manager'
import API from '../../../../supercut/shared/utils/api'
import { IWatermark } from '../../types'

const api = new API()

const Preview = styled.div`
    cursor: pointer;
    height: 50px;
    background-color: ${giphyDarkCharcoal};
    margin: 8px 0px;
    text-align: center;
    display: flex;
    align-items: center;
    border-radius: 4px;
`

const Checkmark = styled.i<{ active?: boolean }>`
    background: ${giphyLightGrey};
    border-radius: 50%;
    color: #000;
    font-size: 12px;
    height: 20px;
    line-height: 22px;
    width: 20px;
    margin-right: 10px;

    ${({ active }) =>
        active &&
        css`
            ${CreationToolUIAnimation.css(CreationToolUIAnimation.PopIn)}
            visibility: visible;
            background: linear-gradient(
                45deg,
                ${CreationToolGradient.colors(CreationToolGradient.BlueGreen)[0]},
                ${CreationToolGradient.colors(CreationToolGradient.BlueGreen)[1]}
            );
        `}
`

const Image = styled.div<{ src: string }>`
    background-image: url(${(props) => props.src});
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
    height: 50px;
    width: 50px;
    margin-right: 14px;
`
const Title = styled.div`
    flex: 3;
    text-align: left;
    font-weight: bold;
    color: ${giphyWhite};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 20px;
`

const EllipsisButton = styled.div`
    cursor: pointer;
    color: ${giphyWhite};
    height: 30px;
    margin-right: 5px;
`

const EllipsisItem = styled.div`
    cursor: pointer;
`

type Props = {
    watermark: IWatermark
    currentlySelected: boolean
}

const WatermarkPreviewItem = ({ watermark, currentlySelected }: Props) => {
    const { setWatermark, setPreviousWatermarks, previousWatermarks } = useContext(CreationCaptureInfoContext)
    const { user } = useContext(UserContext)
    const { sendMessage } = useContext(MessageContext)

    const onChooseClick = () => {
        if (currentlySelected) {
            setWatermark()
        } else {
            setWatermark(watermark)
        }
    }

    const onDelete = async () => {
        if (currentlySelected) {
            setWatermark()
        }
        setPreviousWatermarks(previousWatermarks.filter((wm) => wm.id !== watermark.id))
        try {
            await api.deleteWatermark(user.username, watermark.id)
        } catch (e) {
            sendMessage(`Unable to delete watermark.`, 'error')
        }
    }

    return (
        <Preview onClick={onChooseClick}>
            <Image src={watermark.imageUrl}></Image>
            <Title>{watermark.filename}</Title>
            <Checkmark className="ss-check" active={currentlySelected} />
            <EllipsisButton onClick={(evt) => evt.stopPropagation()}>
                <EllipsisDropdown isHover={true} extendDirectionUp={true}>
                    <EllipsisItem onClick={onDelete}>Delete</EllipsisItem>
                </EllipsisDropdown>
            </EllipsisButton>
        </Preview>
    )
}

export default WatermarkPreviewItem
